"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditOrders = void 0;
const filter_header_1 = require("client/components/filter-header");
const table_1 = require("client/components/material/table");
const table_row_1 = require("client/components/material/table/table-row");
const store_1 = require("client/modules/patients/store");
const store_2 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const order_1 = require("shared/order");
const permissions_1 = require("shared/permissions");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-orders.less");
const columns = [
    {
        center: false,
        id: "site.displayName",
        numeric: false,
        label: "Pharmacy"
    },
    {
        center: false,
        id: "provider.lastName",
        numeric: false,
        label: "Provider"
    },
    {
        center: false,
        id: "order.createDate",
        numeric: false,
        label: "Appt Date & Time"
    },
    {
        center: false,
        id: "order.status",
        numeric: false,
        label: "Status"
    },
    {
        center: false,
        id: "",
        numeric: true,
        label: "Time Remaining"
    }
];
let EditOrders = class EditOrders extends react_1.Component {
    constructor() {
        super(...arguments);
        this.filterText = "";
        this.filterDate = "";
        this.order = "ASC";
        this.orderBy = "order.status";
        this.sortMenu = false;
        this.showCompleted = false;
        this.loadOrders = throttle_debounce_1.debounce(200, () => {
            const searchDate = this.filterDate === "" ? "" : new Date(this.filterDate).toDateString();
            if (store_1.patientsStore.patient.value) {
                store_1.patientsStore.loadOrders({
                    id: store_1.patientsStore.patient.value.id,
                    count: 100,
                    order: this.order,
                    search: this.filterText,
                    searchDate,
                    sort: this.orderBy,
                    showCompleted: this.showCompleted.toString(),
                    start: 0
                });
            }
        });
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadOrders();
        };
        this.onCallback = (value, date) => {
            this.filterText = value;
            this.filterDate = date;
            this.loadOrders();
        };
        this.renderTable = () => {
            const { orders: { value: orders = [] } } = store_1.patientsStore;
            return (React.createElement("div", { className: "orders__list" },
                React.createElement(table_1.MaterialTable, { clickable: true, noMargin: true, columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: orders, renderRow: this.renderTableRow })));
        };
        this.renderTableRow = (row, index) => {
            const providerName = `${row.provider.lastName}, ${row.provider.firstName}`;
            const now = moment();
            const appt = moment(row.createDate);
            const diff = appt.diff(now);
            const duration = moment.duration(appt.diff(now));
            const days = appt.diff(now, "days");
            let timeRemaining = "";
            if (diff > 0) {
                if (days > 0) {
                    timeRemaining = `${timeRemaining} ${days}d`;
                }
                timeRemaining = `${timeRemaining} ${duration
                    .hours()
                    .toString()
                    .padStart(2, "0")}:${duration
                    .minutes()
                    .toString()
                    .padStart(2, "0")}:${duration
                    .seconds()
                    .toString()
                    .padStart(2, "0")}`;
            }
            else {
                timeRemaining = "Over Due";
            }
            const time = moment.tz(row.createDate, row.site.timezone);
            const auditUnsubmitted = row.auditStatus === order_1.AuditStatus.Unsubmitted;
            const auditPending = row.auditStatus === order_1.AuditStatus.Pending;
            const isDev = store_2.usersStore.user.value.groupId === permissions_1.GROUPS.DEV;
            return (React.createElement(table_row_1.MaterialTableRow, { key: index, to: `../../claims/${row.id}` },
                React.createElement(material_ui_1.TableCell, null, row.site.displayName || row.site.name || CONFIG.emptyText),
                React.createElement(material_ui_1.TableCell, null, providerName),
                React.createElement(material_ui_1.TableCell, null,
                    row.createDate && time.format("MM/DD/YYYY hh:mm A"),
                    " (",
                    time.format("z"),
                    ")"),
                React.createElement(material_ui_1.TableCell, { "data-tip": row.message },
                    React.createElement("div", { className: "orders-list__row" },
                        React.createElement("div", { className: `orders-list__status orders-list__status--${row.status}` }),
                        " ",
                        React.createElement("div", { className: "orders-list__status-text" },
                            row.status === order_1.OrderStatus.Ready &&
                                (auditUnsubmitted
                                    ? "Ready for Provider Review"
                                    : auditPending
                                        ? "Approved to Dispense"
                                        : "Ready To Dispense"),
                            row.status === order_1.OrderStatus.Pending && "Pending Adjudication",
                            (row.status === order_1.OrderStatus.Progress ||
                                row.status === order_1.OrderStatus.Executing) &&
                                "In Progress",
                            row.status === order_1.OrderStatus.Reversed && "Canceled",
                            row.status === order_1.OrderStatus.Intended && "Intend to Dispense",
                            row.status === order_1.OrderStatus.Error &&
                                (row.refill ? "Refill Error" : "Error"),
                            row.status === order_1.OrderStatus.ReverseError &&
                                !isDev &&
                                "Pending Reversal",
                            row.status === order_1.OrderStatus.ReverseError &&
                                isDev &&
                                "Failed to Reverse",
                            row.status === order_1.OrderStatus.Refill && "Refill Due",
                            row.status === order_1.OrderStatus.Done && "Dispensed"))),
                React.createElement(material_ui_1.TableCell, null, (row.status !== order_1.OrderStatus.Done &&
                    row.status !== order_1.OrderStatus.Refilled &&
                    row.status !== order_1.OrderStatus.Reversed &&
                    timeRemaining) ||
                    "")));
        };
        this.handleToggle = () => {
            this.showCompleted = !this.showCompleted;
            this.loadOrders();
        };
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    render() {
        return (React.createElement("div", { className: "patient-edit-orders" }, store_2.usersStore.permissions.ReadClaims ? (React.createElement(React.Fragment, null,
            React.createElement(filter_header_1.FilterHeader, { label: "Search", switchChecked: this.showCompleted, switchLabel: "Show Completed Claims", title: "Claims", withDatePicker: true, withSwitch: true, callBack: this.onCallback, filterDate: this.filterDate, filterText: this.filterText, handleToggle: this.handleToggle }),
            this.renderTable(),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" }))) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], EditOrders.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "sortMenu", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "showCompleted", void 0);
EditOrders = __decorate([
    mobx_react_1.observer
], EditOrders);
exports.EditOrders = EditOrders;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/edit-orders/edit-orders.tsx
// module id = 3809
// module chunks = 0